module.exports = __webpack_public_path__ + "media/onboarding_background.baf79570.png";